import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 0C0.895434 0 3.8147e-06 0.89543 3.8147e-06 2L0 13.4877H6.122L7.019 10.2945C7.08 10.078 7.275 9.93169 7.498 9.93069C7.692 9.90964 7.917 10.077 7.98 10.2885L8.918 13.4856H9.086L11.008 3.40808C11.055 3.15952 11.264 2.9691 11.529 3.00417C11.779 3.01921 11.98 3.21765 11.998 3.46821L12.805 14.6272L14.009 8.25694C14.053 8.02141 14.26 7.85003 14.5 7.85003H14.503C14.744 7.85103 14.95 8.02542 14.992 8.26295L15.919 13.4877H21.5C21.775 13.4877 22 13.7112 22 13.9888C22 14.2624 21.775 14.4899 21.5 14.4899H15.5C15.258 14.4899 15.05 14.3155 15.008 14.077L14.485 11.1264L13.076 18.5911C13.029 18.8306 12.822 19 12.584 19C12.574 19 12.564 19 12.555 18.998C12.305 18.984 12.104 18.7845 12.085 18.534L11.276 7.3469L9.991 14.083C9.946 14.3175 9.74 14.4899 9.5 14.4899H8.544C8.322 14.4899 8.127 14.3436 8.065 14.1301L7.511 12.2429L6.982 14.1241C6.92 14.3416 6.724 14.4899 6.5 14.4899H3.08372e-06L3.8147e-06 22C3.8147e-06 23.1046 0.895434 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2Z",
      fill: "#2C3647"
    }, null, -1)
  ]))]))
}
export default { render: render }